import React from 'react';

import { useTranslation } from 'react-i18next';

import { Button, Link } from 'formlabs-web-components/Link';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';

import AddToCart from './AddToCart';
import LeadTime from './LeadTime';
import Price from './Price';

import './ProductListItem.module.css';

const cdnUrl = `${
  process.env.RAZZLE_MAGENTO_MEDIA_URL
}/catalog/product/200x200`;

const ProductListItem = ({ baseUrl, product }) => {
  const [t] = useTranslation();
  const {
    attributes,
    classes,
    media,
    name,
    price,
    sku,
    type_id,
    url
  } = product;

  const to = url ? `${baseUrl}${url}/` : `${baseUrl}${attributes.urlKey}/`;
  // FIXME extract and combine with bundleproduct image thing, also add safeguards
  const image =
    media && media.length
      ? media.filter(item => item.media_type === 'image')[0].file
      : attributes.image;
  const imageSrc = `${cdnUrl}${image}`;

  return (
    <section className={classes} styleName="product">
      <div styleName="image">
        <Link to={to}>
          <img src={imageSrc} alt={name} />
        </Link>
      </div>
      <div styleName="body">
        <div styleName="name">
          <Link to={to}>{name}</Link>
        </div>
        <div styleName="action">
          <Price styleName="price" price={price} />
          {type_id === 'bundle' ? (
            <Button small to={to}>
              {t('Select')}
            </Button>
          ) : (
            <AddToCart quickAdd amount={1} sku={sku} name={name} />
          )}
        </div>
      </div>
      {attributes.isNew && <div styleName="new">{t('new')}</div>}
      {attributes.leadTime ? (
        <LeadTime styleName="lead-time" value={attributes.leadTime} sku={sku} />
      ) : null}
    </section>
  );
};

export default DisplayComponent(ProductListItem);
